import { ScrollToApplyButton } from '#/components/ApplyButton/ScrollToApplyButton';
import { DesktopOnly } from '#/components/Breakpoint/DesktopOnly';
import { DropdownMenuItem } from '#/components/Dropdown/menus/Menu/Item/DropdownMenuItem';
import { SaveListingButton } from '#/components/SaveButton/SaveListingButton';
import { ShareListingButton } from '#/components/ShareListingButton/ShareListingButton';
import { useI18n } from '#/i18n/hooks/useI18n';
import { ListingActionsDropdown } from '#/modules/listing/components/ListingActionsDropdown/ListingActionsDropdown';
import { ListingActionsDropdownCancelRsvp } from '#/modules/listing/components/ListingActionsDropdown/ListingActionsDropdownCancelRsvp';
import { ListingViewActionButtons } from '#/modules/listing/components/ListingView/ActionButtons/ListingViewActionButtons';
import type { ApiEvent } from '#/modules/listing/events/api/types/ApiEvent';
import { RsvpButton } from '#/modules/listing/events/components/RsvpButton/RsvpButton';
import { useRsvpAnswer } from '#/modules/listing/events/hooks/useRsvpAnswer';
import type { OrgDashboardApiEvent } from '#/modules/orgDashboard/api/listing/types/OrgDashboardApiEvent';

type Props = {
  event: ApiEvent | OrgDashboardApiEvent;

  // Save event
  eventSaved: boolean;
  onSaveEvent: () => Promise<void>;
  onUnsaveEvent: () => Promise<void>;

  // Save Org
  orgSaved: boolean;
  shouldShowSaveOrgTooltip: boolean;
  onSaveOrg: () => Promise<void>;
  onUnsaveOrg: () => Promise<void>;
  onDismissSaveOrgTooltip: () => void;
};

export function ViewEventActionButtons({
  event,
  eventSaved,
  onSaveEvent,
  onUnsaveEvent,
  shouldShowSaveOrgTooltip,
  orgSaved,
  onSaveOrg,
  onUnsaveOrg,
  onDismissSaveOrgTooltip,
}: Props) {
  const { i18n } = useI18n();
  const { ownRsvp, cancelRsvp } = useRsvpAnswer(event.id, false);

  return (
    <ListingViewActionButtons>
      {event.hasRsvp ? (
        <RsvpButton listingId={event.id} />
      ) : (
        <ScrollToApplyButton
          applied={false}
          eventName="Join Button on Event Listing"
        >
          {i18n('Join')}
        </ScrollToApplyButton>
      )}

      <SaveListingButton
        listingType={event.type}
        listingSaved={eventSaved}
        onSaveListing={onSaveEvent}
        onUnsaveListing={onUnsaveEvent}
        orgDetails={{
          shouldShowSaveOrgTooltip,
          onSaveOrg,
          onDismissSaveOrgTooltip,
        }}
      />

      <DesktopOnly>
        <ShareListingButton
          disabled={!event.url}
          listingId={event.id}
          listingType={event.type}
          listingUrl={event.url}
        />
      </DesktopOnly>

      <ListingActionsDropdown
        listingId={event.id}
        listingType={event.type}
        listingUrl={event.url}
        orgDetails={
          event.org
            ? {
                orgId: event.org.id,
                orgName: event.org.name,
                orgType: event.org.orgType,
                orgSaved,
                onSaveOrg,
                onUnsaveOrg,
              }
            : null
        }
        extraMenuItem={
          ownRsvp?.answer === 'GOING' && (
            <DropdownMenuItem>
              <ListingActionsDropdownCancelRsvp onCancelRsvp={cancelRsvp} />
            </DropdownMenuItem>
          )
        }
      />
    </ListingViewActionButtons>
  );
}
